export default __webpack_public_path__ + "static/media/cs-a018-6.aaf4f2f2.svg";